import React from 'react'
import {
	tea,
	coffee,
	frappe,
	shakes,
	mocktails,
	dessert,
	hotChocolate,
	lemonade,
	icedTea,
} from '../images/sliderIcons/index.js'

const Slider = () => {
	let text = ['Tea', 'Coffee', 'Frappe', 'Shakes', 'Mocktails', 'Dessert', 'Hot Chocolate', 'Lemonade', 'Iced Tea']
	return (
		// <div className='mb-10 overflow-x-auto scroll-smooth touch-pan-x'>
		<div className='sliderBox '>
			{[tea, coffee, frappe, shakes, mocktails, dessert, hotChocolate, lemonade, icedTea].map((image, key) => {
				return (
					<div
						key={key}
						className='silderItem flex '
						style={{
							background:
								'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), radial-gradient(145.16% 498.23% at 92.36% 100%, rgba(235, 0, 255, 0.2) 33.19%, rgba(0, 0, 0, 0) 100%), radial-gradient(120.97% 520.71% at 14.58% 25.81%, rgba(19, 31, 108, 0.78) 9.96%, rgba(19, 31, 108, 0) 100%) ',
						}}
					>
						<div className=''>
							<img className='h-6 w-6 bg-white rounded-full p-1 mx-2 ' src={image} alt='Slider icon'></img>
						</div>

						<h5 className='title ml-4'>{text[key]}</h5>
					</div>
				)
			})}
		</div>
		// </div>
	)
}

export default Slider
